import React from 'react';
import Routes from 'apps/portal/routes.erb';
import LayoutHeader from 'shared/layout-header';
import AuthLayout from 'apps/portal/layouts/auth';
import ForgotPasswordFormContainer from './components/forgot-password-form/container';

export default function PortalForgotReset() {
  return (
    <AuthLayout
      headerButtons={(
        <LayoutHeader.Button
          href={Routes.new_identity_registration_path()}
          theme="text"
        >
          Sign Up
        </LayoutHeader.Button>
      )}
      title="Forgot Password"
    >
      <ForgotPasswordFormContainer />
    </AuthLayout>
  );
}
